import React from 'react';
import HeroBanner from './HeroBanner';
import MobileBanking from './MobileBanking';
import SalaryProcessing from './SalaryProcessing';
import StrategicPartners from './StrategicPartners';
import AssetFinancing from './AssetFinancing';

const Services = () => {
    return (
        <>
           
            <HeroBanner />
            <MobileBanking/>
            <SalaryProcessing/>
            <AssetFinancing/>
            <StrategicPartners/>
            
        </>
    );
};

export default Services;
